import React from 'react'
import {Card} from '@blueprintjs/core'


export default function DeploymentPrompt({global, dispatch, location, siteMeta}) {

  function handleDeploymentSelect(deployment_id) {
    dispatch({
      type: 'SET_ACTIVE_DEPLOYMENT',
      data: {
        deployment_id,
      },
    })
  }


  return (
    <div
      style={{
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          //
        }}
      >
        Select the account you'd like to view:
      </div>

      {global.all_deployments?.map((deployment) => (
        <DeploymentPromptItem
          key={deployment.deployment_id}
          deployment={deployment}
          onClick={handleDeploymentSelect.bind(null, deployment.deployment_id)}
        />
      ))}

    </div>
  )
}


function DeploymentPromptItem({deployment, onClick}) {
  return (
    <Card
      onClick={onClick}
      style={{
        cursor: 'pointer',
      }}
    >

      <div
        style={{
          fontSize: '1.15em',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        {deployment.deployment_name_long}
      </div>

      <div
        style={{
          fontSize: '0.75em',
          cursor: 'pointer',
        }}
      >
        {deployment.deployment_id}
      </div>

    </Card>
  )
}
